// eslint-disable-next-line import/no-extraneous-dependencies
import Ajv from 'ajv';
import chatbot from './chatbot.json';
import secrets from './secrets.json';
import actions from './actions.json';
import files from './files.json';
import entrypoint from './entrypoint.json';
import messages from './messages.json';
import transitions from './transitions.json';
import variables from './variables.json';
import checkbox from './actions/inputTypes/checkbox.json';
import date from './actions/inputTypes/date.json';
import defaultJson from './actions/inputTypes/default.json';
import email from './actions/inputTypes/email.json';
import evaluate from './actions/inputTypes/eval.json';
import location from './actions/inputTypes/location.json';
import media from './actions/inputTypes/media.json';
import number from './actions/inputTypes/number.json';
import password from './actions/inputTypes/password.json';
import phone from './actions/inputTypes/phone.json';
import radio from './actions/inputTypes/radio.json';
import text from './actions/inputTypes/text.json';
import functions from './functions.json';
import version from './version.json';
import storage from './storage.json';
import sendMessage from './actions/sendMessage.json';
import callApi from './actions/callApi.json';
import mapResults from './actions/mapResults.json';
import callFunction from './actions/callFunction.json';
import inputType from './actions/inputType.json';

const ajv = new Ajv({
  allErrors: true,
  schemas: [
    chatbot,
    entrypoint,
    secrets,
    actions,
    files,
    messages,
    transitions,
    variables,
    checkbox,
    date,
    defaultJson,
    email,
    evaluate,
    location,
    media,
    number,
    password,
    phone,
    radio,
    text,
    functions,
    version,
    storage,
    sendMessage,
    callApi,
    mapResults,
    callFunction,
    inputType,
  ],
});

export default () => ({
  getErrorsAsString: ajv.errorsText,
  validate: ajv.getSchema('http://twnel.com/schemas/chatbot.json'),
});
